import Header from '../../components/Header';
import Footer from '../../components/Footer';

export default function TermsUsePage() {
  return (
    <div>
      <Header/>
      <main className='wrapper top-space bottom-space'>
        <h1 className='text-title2 lg:text-display1 text-center'>링콜 서비스 이용약관</h1>
        
        <div className='top-space space-y-[40px]'>
          <div>
            <h2 className='text-heading3'>제1장 총칙</h2>
            <div className='mt-[20px] space-y-[20px]'>
              <div>
                <h3 className='text-body1'>제1조 (목적)</h3>
                <p>
                    (주)모듈링크(이하 “회사”라 합니다)는 회사가 제공하는 서비스에 대한 약관(이하 ‘본 약관’이라 합니다)을 마련하였습니다. 본 약관은 회사와 회원의 권리와 의무, 책임 관계, 기타 필요한 사항을 규정하고 있습니다. 
                </p>
              </div>
              <div>
                  <h3 className='text-body1'>제2조 (정의)</h3>
                  <ol>
                      <li>
                          링콜<br/>
                          회원이 당사의 전용 제품, 휴대전화, PC 등을 통하여 모빌리티 안전 및 부가 서비스를 이용할 수 있도록 회사가 제공하는 일체의 서비스를 말합니다.
                      </li>
                      <li>
                          링콜 서비스<br/>
                          링콜을 통해서 제공하는 일체의 모빌리티 안전 및 부가 서비스를 의미합니다. 구체적인 서비스의 종류 및 내용은 제8조에서 정하고 있습니다.
                      </li>
                      <li>
                          회원<br/>
                          본 약관에 동의하고 회사가 제공하는 링콜 서비스를 이용하는 고객을 말합니다.
                      </li>
                      <li>
                          유료 서비스<br/>
                          링콜 서비스 중 회원이 회사에 요금, 이용료, 수수료 등(이하 통칭하여 “이용요금”이라 합니다)을 지급하는 서비스를 말합니다.
                      </li>
                      <li>
                          제휴 서비스<br/>
                          회사와 제휴한 사업자(이하 “제휴사”라 합니다.)가 링콜를 통해 제공하는 유료 서비스를 말합니다.
                      </li>
                      <li>
                          자동결제<br/>
                          회원이 최초 결제 수단 등의 정보를 입력한 이후 이용요금이 결제될 때마다 별도의 인증 과정 없이 자동으로 결제되는 것을 말합니다. 자동결제와 관련한 상세한 정책은 개별 전자지급결제대행 업자의 결제서비스 이용약관 및 서비스 정책을 따릅니다.
                      </li>
                      <li>
                          링콜 포인트<br/>
                          회원이 직접 유상 결제하는 등의 방법으로 충전하거나 링콜 서비스 이용 등을 통해서 적립 받아 링콜을 통해 제공하는 유료 서비스 결제 시 사용할 수 있는 전자적 지급수단을 말합니다. 
                      </li>
                  </ol>
              </div>
              <div>
                  <h3 className='text-body1'>제3조 (약관의 효력 및 변경)</h3>
                  <ol>
                      <li>
                          본 약관의 내용은 링콜 서비스 화면에 게시하거나 기타의 방법으로 회원에게 공시하고, 본 약관에 동의한 회원에게 그 효력이 있습니다.
                      </li>
                      <li>
                          회사는 필요한 경우 관련 법령을 위배하지 않는 범위 내에서 본 약관을 변경할 수 있습니다. 회사가 본 약관을 변경할 경우에는 적용 일자, 변경 사유를 명시하여 적용 일자 7일 전부터 공지하거나, 회원에게 개별 통지합니다. 회원에게 불리한 약관의 변경인 경우에는 그 적용 일자 30일 전부터 공지하거나, 회원에게 개별 통지합니다.
                      </li>
                      <li>
                          회사가 제2항에 따라 회원에게 공지 또는 통지하면서 ‘약관 변경 적용 일까지 거부 의사를 표시하지 않을 경우 약관의 변경에 동의한 것으로 본다’는 내용을 명확하게 고지하였음에도 회원이 명시적으로 약관 변경에 대한 거부 의사를 표시하지 않은 경우 회원은 변경된 약관 내용에 동의한 것으로 간주합니다.
                      </li>
                      <li>
                          회원이 변경된 약관 사항에 동의하지 않으면 회사는 개정 약관의 내용을 적용할 수 없고, 회원은 링콜 서비스 이 용을 중단하고 이용계약을 해지할 수 있습니다. 다만, 회사는 개정 약관에 동의하지 않은 회원에게 기존약관을 적용할 수 없는 특별한 사정이 있는 경우에는 해당 회원과의 이용 계약을 해지할 수 있습니다.
                      </li>
                  </ol>
              </div>
              <div>
                  <h3 className='text-body1'>제4조 (약관의 해석 및 약관 외 준칙)</h3>
                  <ol>
                      <li>
                          회사는 필요한 경우 개별 링콜 서비스에 관하여 적용될 사항을 위해 운영 정책, 이용 지침 등(이하 통칭하여 "운 영정책 등"이라 합니다)을 정하여 운영할 수 있습니다. 해당 내용은 링콜 화면, 홈페이지 등을 통해 공지합니다.
                      </li>
                      <li>
                          본 약관에 규정되지 않은 사항에 관해서는 관련 법령 또는 운영 정책 등에서 정한 바에 따릅니다.
                      </li>
                      <li>
                          회원은 본 약관 및 운영 정책 등의 내용에 변경이 있는지 여부를 확인하여야 합니다. 회사는 회원이 이를 확인하지 않아 발생한 손해에 대해서는 책임을 부담하지 않습니다.
                      </li>
                  </ol>
              </div>
              <div>
                  <h3 className='text-body1'>제5조 (회원에 대한 통지 등)</h3>
                  <ol>
                      <li>
                          회사는 회원이 등록한 E-mail 주소 또는 SMS, App push, 회사 또는 링콜 서비스의 SNS 등을 통해 회원에 대한 통지를 할 수 있습니다. 다만, 회사가 불특정 다수 회원에 대해 통지를 하는 경우 링콜 화면에 게시하는 방법 등을 활용할 수 있습니다.
                      </li>
                      <li>
                          회사는 링콜 서비스를 운영함에 있어 링콜 서비스 관련 각종 정보를 개별 링콜 화면에 게시하거나 제1항에 정 한 방법으로 회원에게 제공할 수 있습니다.
                      </li>
                      <li>
                          회사는 링콜 서비스를 운영하면서 회사 또는 제휴사의 각종 광고를 링콜 화면에 게시하거나 회원의 동의를 얻어 제1항에 정한 방법으로 회원에게 제공할 수 있습니다.
                      </li>
                      <li>
                          회원의 연락처 미기재, 변경 후 미수정 등으로 인하여 개별 통지가 어려운 경우 제1항 단서의 공지를 함으로써 개별 통지를 한 것으로 봅니다.
                      </li>
                  </ol>
              </div>
              <div>
                  <h3 className='text-body1'>제6조 (면책사항)</h3>
                  <ol>
                      <li>
                          회사는 링콜 서비스를 이용하는 회원에게 안전한 주행을 위한 안내를 제공하는 시스템을 운영/관리/제공할 뿐, 회원의 사고를 방지할 수 없습니다. 또한, 사고 예방을 위한 안내는 데이터를 기반으로 한 통계 예측으로 100% 신뢰할 수 없으며, 고객의 안전 주행을 유도하기 위한 참고 정보입니다. 따라서, 회사가 위험이 없다고 판단하였을지라도 고객 스스로 안전 주행을 통해 사고를 예방하기 위한 각별한 주의를 기울여야 합니다.
                      </li>
                      <li>
                          회사는 링콜 서비스를 이용하는 회원 또는 회원이 보유한 제품에서 송출된 응급신호 코드를 접수하여 고객을 대신해 응급출동 요청을 진행할 뿐, 직접 현장에 출동하거나 응급구호 활동에 직접적인 관여를 하지 않습니다. 따라서, 회사는 구호 활동 및 사고 피해에 대한 일체의 책임을 지지 않습니다. 또한, 응급구호 활동 중에 발생한 상호 간의 분쟁은 회사의 과실이 없는 한 개입하지 않으며, 책임을 부담하지 않습니다.
                      </li>
                      <li>
                          회사는 회원과 서비스 제공자 간의 거래와 관련하여 서비스 신청 또는 수락 의사의 존부 및 진정성, 거래 대상의 품질, 완전성, 안전성, 적법성 및 타인의 권리에 대한 비침해성, 회원 또는 서비스 제공자가 제공한 정보 및 그 정보의 진실성 또는 적법성 등 일체에 대하여 보증하지 않고, 그와 관련하여 어떠한 책임도 부담하지 않습니 다. 다만, 제1항 단서의 경우, 회사는 회사가 거래 당사자로서 회원에게 제공한 정보에 대하여는 그 진실성 또 는 적법성 등에 대하여 거래 당사자로서 책임을 부담합니다.
                      </li>
                      <li>
                          회사는 회원이 링콜에 입력한 정보, 자료, 사실의 신뢰도 및 정확성 등의 내용과 관련된 책임을 부담하지 않습니다. 또한 회사는 링콜 화면 내에서 링크, 배너 등을 통하여 연결된 제3자와 회원 간의 거래 등에 관하여 개입하지 않고, 해당 거래 등에 대하여 어떠한 책임도 부담하지 않습니다.
                      </li>
                      <li>
                          회사는 관계 법령의 변경, 천재지변, 디도스(DDOS) 공격, IDC 장애, 기간통신사업자의 회선 장애 또는 이에 준하는 불가항력으로 인하여 링콜 서비스를 제공할 수 없는 경우에는 링콜 서비스 제공에 관한 책임을 부담하지 않습니다.
                      </li>
                      <li>
                          회사는 회원이 불법행위 또는 부적절한 방법으로 링콜 서비스를 이용하여 발생한 제반 결과(서비스 이용 불능, 각종 사고 등)에 대하여, 회사의 귀책 사유가 없는 한 책임을 부담하지 않습니다.
                      </li>
                      <li>
                          회사는 회원이 링콜 서비스를 이용하여 기대하는 수익을 상실하였거나 링콜 서비스를 통해 얻은 2차적인 자료로 인하여 손해가 발생하는 등, 회사가 예상할 수 없는 상황에 대하여 책임을 부담하지 않습니다.
                      </li>
                      <li>
                          링콜 서비스는 회원의 안전과 신속한 구조를 위한 보조 수단일 뿐, 실제 주행 상황 및 긴급상황 등과 다를 수 있으므로 반드시 교통법규와 실제 도로 상황에 적합하게 주행해야 합니다. 회사는 회원의 교통법규 위반 및 부주의 등으로 발생하는 회원 또는 제3자의 손해에 대해서는 책임을 부담하지 않습니다.
                      </li>
                  </ol>
              </div>
            </div>
          </div>
          <div>
            <h2 className='text-heading3'>제2장 링콜의 이용</h2>
            <div className='mt-[20px] space-y-[20px]'>
              <div>
                <h3 className='text-body1'>제7조 (링콜 가입)</h3>
                <ol>
                    <li>
                        링콜에 가입하고자 하는 자는 링콜 App를 설치 후 실행한 상태에서 본 약관에 동의하여 링콜 가입 절차를 진행함으로써 이용신청을 하고, 회사가 이를 승낙함으로써 링콜과의 이용계약이 체결됩니다.
                    </li>
                    <li>
                        제1항에 따라 가입 절차를 진행하고자 하는 자는 회사에서 제공하는 회원 가입신청 양식에 따라 필요 사항을 기재하여야 합니다. 회원 가입 시 기재 항목은 필수 기재 항목과 선택 기재 항목으로 구분되어 있고, 필수 기재 항목의 경우 반드시 입력하여야 합니다.
                    </li>
                    <li>
                        회사는 제1항에 따른 가입 절차의 진행 과정에서 실명 확인 또는 본인인증 등 절차의 진행을 요구할 수 있습니다. 링콜에 가입하여 이용하고자 하는 자는 회사가 요구하는 절차를 모두 거쳐야 합니다.
                    </li>
                    <li>
                        회사는 원칙적으로 제1항에 따른 이용신청을 승낙합니다. 다만, 회사는 이용신청이 다음 각 호에 해당하는 경우 에는 승낙하지 않거나 사후적으로 이용계약을 해지할 수 있습니다.
                        <ol>
                            <li>
                                본인 명의의 휴대전화 또는 휴대전화 번호를 보유하지 않은 경우
                            </li>
                            <li>
                                타인의 명의를 이용하여 이용신청을 한 경우
                            </li>
                            <li>
                                14세 미만의 아동이 이용신청을 한 경우
                            </li>
                            <li>
                                회사가 요구하는 실명 확인 또는 본인인증 등 절차를 거치지 않았거나, 허위 또는 부적절한 방법으로 진행 한 경우
                            </li>
                            <li>
                                이용신청 과정에서 허위의 정보를 기재하였거나, 회사가 요구하는 기재 항목을 기재하지 않거나 오기한 경우
                            </li>
                            <li>
                                어떠한 사유로 이전에 회원 자격을 박탈당하였거나 이용계약을 해지당했던 자가 이용신청을 한 경우
                            </li>
                            <li>
                                어떠한 사유로 이용정지 등의 제재를 받은 회원이 그 제재 기간 중 탈퇴 등을 통하여 이용계약을 임의로 해지한 후 이용신청을 한 경우
                            </li>
                            <li>
                                본 약관 또는 관련 법령 등에 위배되거나 회사가 정한 이용신청 요건을 충족하지 못하는 등 위법 또는 부적절한 이용신청임이 확인된 경우
                            </li>
                            <li>
                                회사의 사업 운영, 사회의 안녕질서 또는 미풍양속을 저해하거나 저해할 목적으로 이용신청을 한 경우
                            </li>
                            <li>
                                기타 제1호 내지 제9호에 준하는 사유 또는 이용신청을 한 자의 귀책 사유로 인하여 회사가 승낙할 수 없는 경우
                            </li>
                        </ol>
                    </li>
                    <li>
                        회사는 기술상 또는 설비상 문제가 있는 경우에는 이용신청에 대한 승낙을 보류하거나 거절할 수 있습니다.
                    </li>
                    <li>
                        회사가 본 조에 따라 이용신청의 승낙을 보류하거나 거절하는 경우, 회사는 부득이한 사유가 없는 한 관련 사항을 제5조에 준하는 방법으로 해당 신청자에게 통지합니다.
                    </li>
                    <li>
                        회원이 본 이용약관에 동의하고 링콜에 가입하는 것은, 링콜 및 링콜 서비스를 회사에서 제공하는 방식과 내용으로 이용하고 회사에서 정한 본 약관 및 운영 정책 등을 준수한다는 의사를 표시한 것으로 간주됩니다. 
                    </li>
                </ol>
            </div>
            <div>
                <h3 className='text-body1'>제8조 (링콜 서비스의 내용)</h3>
                <ol>
                    <li>
                        링콜 서비스의 종류와 내용은 다음과 같습니다.<br/>
                        - 회원의 위치정보와 센서 정보를 통해 주행 사고 위험 안내와 센서에 의해 사고 감지 또는 회원의 요청에 따른 응급지원 요청 서비스 및 부가서비스 일체<br/>
                        - 기타 회사가 회원의 생활안전 및 편의 향상 등을 위해 제공하는 서비스<br/>
                    </li>
                    <li>
                        회사는 회원의 링콜 서비스 이용에 있어 회원의 편의를 도모하고 서비스 이용의 효율을 높이기 위해 다양한 유료 서비스를 구성하여 제공할 수 있고, 구체적인 사항은 제12조에 따릅니다.
                    </li>
                    <li>
                        회사는 제휴사가 제공하는 다양한 제휴 서비스를 링콜을 통하여 제공할 수 있습니다. 제휴 서비스 이용과 관련하여서는 제휴사의 이용약관을 따르고, 회사는 회원이 해당 이용약관을 확인할 수 있도록 제휴사의 홈페이지 등 에 게시되어 있는 이용약관을 연결합니다. 또한 회사는 회원이 제휴 서비스를 이용하기 전에 링콜 화면을 통하여 이용 요금 등을 안내합니다.
                    </li>
                    <li>
                        제1항에 따른 링콜 서비스의 이용 방법 및 이용상 주의 사항 등은 링콜을 통한 서비스 이용 시 화면을 통하여 안내하거나, 링콜 내 공지 사항 또는 운영 정책 등을 통하여 공지합니다.
                    </li>
                    <li>
                        회사는 제1항의 각 링콜 서비스를 개별 애플리케이션을 통해 제공할 수 있습니다
                    </li>
                </ol>
            </div>
            <div>
                <h3 className='text-body1'>제9조 (링콜 서비스의 변경 등)</h3>
                <ol>
                    <li>
                        회사는 상당한 이유가 있는 경우에 운영상, 기술상의 필요에 따라 제공하고 있는 전부 또는 일부의 서비스를 추 가하거나 축소하는 등 변경할 수 있습니다. 다만, 변경된 내용이 중대하거나 회원에게 불리한 경우에는 회사가 해당 서비스를 제공받는 회원에게 제5조에서 정한 방법으로 통지합니다.

                    </li>
                    <li>
                        회사는 전항에 따른 서비스 변경에 대한 동의를 거절한 회원에 대하여는 변경 전 서비스를 제공합니다. 다만, 그러한 서비스 제공이 불가능할 경우 해당 서비스의 제공을 중지하거나 이용계약을 해지할 수 있습니다.
                    </li>
                    <li>
                        회사는 다음 각 호에 해당하는 경우 링콜 서비스의 전부 또는 일부를 제한하거나 중단할 수 있습니다.
                        <ol>
                            <li>
                                통신, 전력 등의 공급이 중단되거나 정보통신설비의 보수점검, 증설, 교체, 이전, 고장, 장애 또는 운영상 상당한 이유가 있는 경우
                            </li>
                            <li>
                                링콜 서비스 제공을 위한 제3자와의 계약 종료 또는 경영상의 판단 등 회사의 제반 사정으로 링콜 서비스 를 유지할 수 없는 경우
                            </li>
                            <li>
                                파산 또는 회생절차 개시 등 정상적인 영업활동이 곤란한 경우
                            </li>
                            <li>
                                기타 천재지변, 전쟁 및 폭동, 테러 등 국가비상사태, 해킹, DDOS 공격 등 불가항력적 사유가 있는 경우
                            </li>
                        </ol>
                    </li>
                    <li>
                        회사는 제3항에 의한 링콜 서비스 제한 또는 중단의 경우 제5조에서 정한 방법으로 회원에게 통지합니다. 다만, 회사가 통제할 수 없는 사유로 인하여 사전 통지가 불가능한 경우에는 그 사유가 종료된 후 즉시 통지합니다.
                    </li>
                    <li>
                        회사는 본 조에 따른 링콜 서비스의 변경, 제한, 중단 등으로 발생하는 문제에 대해서 회사에 귀책 사유가 없으면 책임을 부담하지 않습니다.
                    </li>
                    <li>
                        회사는 정기 점검을 실시할 수 있고, 정기 점검 시 링콜 서비스의 전부 또는 일부가 중단될 수 있습니다. 회사는 점검 시간 등 상세 사항을 링콜 내의 공지 사항 또는 링콜 화면 등에 공지합니다. 
                    </li>
                </ol>
            </div>
            <div>
                <h3 className='text-body1'>제10조 (링콜 앱에 입력하는 보험정보)</h3>
                <ol>
                    <li>
                        링콜은 고객의 주행 중에 발생하는 사고로 인한 피해의 보상을 목적으로 한 보험 서비스를 제공하지 않습니다. 다만, 고객의 교통사고에 대한 대비를 위한 목적으로 보험상품을 알선할 수 있고, 가입 여부는 고객의 선택사항입니다  
                    </li>
                    <li>
                        링콜 앱에 입력하는 가입 보험 정보는 유사시 고객을 대신하여, 보험사에 사고 지원 처리를 요청하기 위한 정보로 입력 여부는 선택사항입니다.
                    </li>
                </ol>
            </div>
            <div>
                <h3 className='text-body1'>제11조 (이용 계약해지 및 이용 제한)</h3>
                <ol>
                    <li>
                        회원은 언제든지 회사에 이용계약 해지의 의사를 통지함으로써 이용계약을 해지할 수 있습니다. 다만, 회원은 해 지 의사를 통지하기 전에 현재 진행 중인 모든 유료 서비스의 거래를 완료하거나 철회 또는 취소하여야 하며, 유상으로 구매한 링콜 포인트 잔액을 환급받아야 합니다. 만일 결제 실패에 따른 미수가 있을 경우에는, 회원은 해당 결제를 완료한 후 해지 의사를 통지하여야 합니다.
                    </li>
                    <li>
                        회사는 제1항에 따른 이용계약 해지로 인해 발생할 수 있는 불이익 등에 대하여 귀책 사유가 없으면 책임을 부담하지 않습니다. 회사가 이용계약에 기초하여 회원에게 무상으로 지급한 링콜 포인트 및 혜택은 이용계약 해지 와 함께 소멸합니다.
                    </li>
                    <li>
                        회사는 링콜 회원 가입 후 3개월 동안 링콜 서비스 사용 이력이 없는 회원에 대해서는, 일정 기간을 정하여 사용 의사를 확인한 후 이용계약을 종료할 수 있습니다.
                    </li>
                    <li>
                        회원의 귀책 사유로 인하여 이용계약이 해지되더라도 해지 이전에 이미 시작된 링콜 서비스 이용 건에 대해서는 본 약관이 계속 적용됩니다.
                    </li>
                    <li>
                        회원의 귀책사유로 인하여 이용계약이 해지됨으로써 발생한 손해는 당해 회원이 부담하여야 합니다.
                    </li>
                    <li>
                        서비스 이용이 제한된 회원은 해당 제한 내용에 따라 링콜 서비스를 이용할 수 없습니다.
                    </li>
                    <li>
                        회사는 회원이 본 약관에 따른 의무를 위반하는 경우 서비스 이용을 제한하거나 이용계약을 해지할 수 있고, 이 경우 발생하는 모든 책임은 회원이 부담합니다. 회사는 필요한 경우 회원의 위반 행위를 관련 정부 기관 또는 사법기관에 통지할 수 있습니다.
                    </li>
                    <li>
                        회사가 본 조항에 따라 서비스 이용을 제한하거나 이용계약을 해지하는 경우, 회사는 제5조에서 정한 방법으로 사전에 회원에게 통지합니다. 단, 부득이한 사유로 인하여 사전 통지가 불가능한 경우에는 그 사유가 종료된 후 즉시 통지합니다.
                    </li>
                    <li>
                        회원은 전항의 통지일로부터 10일 이내에 항변 및 소명을 할 수 있고, 해당 항변 및 소명이 정당한 경우 회사는 서비스 이용 제한 또는 이용계약 해지를 취소할 수 있습니다. 단, 회원이 기한 내 항변 또는 소명을 하지 않은 경우, 서비스 이용 제한 또는 이용계약 해지에 동의한 것으로 간주합니다. 
                    </li>
                </ol>
            </div>
            <div>
                <h3 className='text-body1'>제12조 (링콜 포인트 등)</h3>
                <ol>
                    <li>
                        회원은 회사가 지정한 지불수단을 통해 링콜 포인트를 유상 구매할 수 있습니다.
                    </li>
                    <li>
                        회사는 회원의 링콜 서비스 이용, 링콜 포인트 유상 구매, 이벤트 참여 등의 경우, 회사의 정책에 따라 회원에 게 링콜 포인트 및 다양한 혜택 등을 무상 지급할 수 있습니다. 무상으로 지급된 링콜 포인트 및 혜택 등은 회사에서 정한 유효기간 내에서 회사가 정한 방법으로만 사용 가능합니다.
                    </li>
                    <li>
                        회원은 유료 서비스 이용 시 다른 결제 수단과 함께 링콜 포인트를 사용할 수 있습니다. 단, 회사는 링콜 서비 스 및 제휴 서비스의 특성이나 제휴사의 정책상 결제 수단을 제한할 수 있습니다.
                    </li>
                    <li>
                        링콜 포인트 및 혜택 등의 부여 및 사용에 관한 상세한 사항은 회사가 정한 정책에 따르며, 회사는 링콜에서 이를 안내합니다.
                    </li>
                    <li>
                        회원은 링콜 전자금융거래 이용약관에서 정한 바에 따라 유상으로 구매한 링콜 포인트를 환급받을 수 있으며, 무상으로 지급받은 링콜 포인트 및 혜택 등은 어떠한 경우에도 유상으로 거래하거나 현금으로 환급, 전환될 수 없습니다.
                    </li>
                    <li>
                        다음 각 호에 해당하는 경우 해당 링콜 포인트 또는 혜택 등이 자동 소멸됩니다.
                        <ol>
                            <li>
                                유상으로 구매한 링콜 포인트의 상사 소멸시효가 경과하는 경우
                            </li>
                            <li>
                                무상으로 지급받은 링콜 포인트 또는 혜택 등의 유효기간이 만료되는 경우
                            </li>
                        </ol>
                    </li>
                    <li>
                        회원이 부당 또는 부정하게 링콜 포인트 및 혜택 등을 취득한 경우 회원은 링콜 포인트 및 혜택 등을 사용할 수 없으며 회사는 이를 회수할 수 있습니다. 
                    </li>
                </ol>
            </div>
            </div>
          </div>
          <div>
            <h2 className='text-heading3'>제3장 유료서비스의 이용</h2>
            <div className='mt-[20px] space-y-[20px]'>
              <div>
                <h3 className='text-body1'>제13조 (유료서비스의 이용)</h3>
                <ol>
                    <li>
                        회사는 회원이 유료 서비스 이용 시 회원이 이해하고 실수 또는 착오 없이 거래할 수 있도록 해당 유료 서비스의 정보를 제공합니다. 
                    </li>
                    <li>
                        회원이 유료 서비스 이용 시 지급하여야 할 수수료, 이용료 등은 이용하는 유료 서비스의 내용에 따라 다르고, 회 사는 개별 유료 서비스 이용요금의 세부 조건을 링콜을 통해 안내합니다.
                    </li>
                    <li>
                        유료 서비스 이용 시 취소 수수료가 발생할 수 있고, 회사는 개별 유료 서비스의 취소 수수료 발생 조건 및 취소 수수료 금액 등의 세부 조건을 링콜을 통해 안내합니다. 
                    </li>
                </ol>
            </div>
            <div>
                <h3 className='text-body1'>제14조 (결제의 이용)</h3>
                <ol>
                    <li>
                        회원은 회사가 정한 각 서비스별 이용 정책에 따라 링콜을 통한 자동결제 또는 현장에서 서비스 제공자에 대한 직접 결제(이하 “현장 결제"라 합니다) 중 가능한 방법을 선택하여 링콜 서비스 이용 요금을 결제할 수 있습니다.
                    </li>
                    <li>
                        회원이 자동결제를 이용하는 경우, 다음 각 호에 동의한 것으로 간주합니다. 
                        <ol>
                            <li>
                                자동결제 이용에 동의한 회원은 링콜 서비스 이용 요금에 대해 별도의 인증과정 없이 결제를 하겠다는 의사 표시를 한 것으로 봅니다.
                            </li>
                            <li>
                                자동결제 시점에 회원의 신용카드 등의 유효성, 한도 등의 문제로 결제 실패가 발생한 경우에 미수로 처리되며, 해당 미수 금액이 정상적으로 결제되기 전까지는 해당 회원은 서비스 이용이 제한됩니다.
                            </li>
                            <li>
                                제2호에 따라 미수가 발생한 경우, 회사는 회사가 정한 정책에 따라 회원에 대한 별도 고지 없이 회원이 등록한 결제 수단으로 재결제 시도를 진행할 수 있습니다.
                            </li>
                            <li>
                                결제 시점에 시스템 장애로 인하여 결제 실패가 된 경우에는, 시스템 정상화가 된 시점에 회원에 대한 별도 고지 없이 다시 결제를 진행합니다. 
                            </li>
                        </ol>
                    </li>
                </ol>
            </div>
            <div>
                <h3 className='text-body1'>제15조 (환불)</h3>
                <ol>
                    <li>
                        회원의 귀책 사유 없이 시스템 오류 등 정상적으로 링콜 서비스를 이용하지 못하거나 초과 결제 또는 중복결제 등의 문제가 발생한 경우, 회사는 해당 서비스의 정상적인 이용을 전제로 부과된 이용요금 또는 잘못 결제된 이용 요금, 취소 수수료의 전부 또는 일부를 해당 회원에게 환불합니다. 
                    </li>
                    <li>
                        회원이 수수료 또는 이용료의 적정성에 대한 이의를 제기하거나 환불 요청을 하고자 하는 경우 직접 거래당사자에게 하여야 합니다. 다만, 회사가 회원에게 직접 또는 회사로부터 업무를 위탁받는 자를 통하여 서비스를 제공한 경우에는 회사에 이의를 제기하거나 환불요청을 할 수 있습니다. 
                    </li>
                    <li>
                        회사는 회원이 지불한 결제 수단과 동일한 수단으로 환불합니다. 다만, 동일한 수단으로 환불이 불가능한 경우 현금 등 다른 수단으로 환불할 수 있습니다
                    </li>
                </ol>
            </div>
            </div>
          </div>
          <div>
            <h2 className='text-heading3'>제4장 이용계약 당사자의 의무</h2>
            <div className='mt-[20px] space-y-[20px]'>
              <div>
                  <h3 className='text-body1'>제16조 (회사의 의무)</h3>
                  <ol>
                      <li>
                          회사는 관련 법령과 본 약관이 금지하거나 미풍양속에 반하는 행위를 하지 않고, 회원들에게 계속적이고 안정적으로 서비스를 제공하기 위하여 최선을 다합니다. 
                      </li>
                      <li>
                          회사는 링콜 서비스와 관련한 회원의 불만 사항이 접수되는 경우 이를 신속하게 처리하여야 하고, 신속한 처리가 곤란한 경우 그 사유와 처리 일정을 제5조에서 정한 방법으로 통지합니다
                      </li>
                  </ol>
              </div>
              <div>
                  <h3 className='text-body1'>제17조 (회원의 의무)</h3>
                  <ol>
                      <li>
                          회원은 링콜 서비스를 이용하기 전에 개별 서비스, 유료 서비스, 제휴 서비스 등의 이용 방법 및 조건 등을 확인하여야 합니다. 이용 방법 및 조건 등을 확인하지 않고 서비스를 이용하여 발생한 손실, 손해에 대한 책임은 회 원 본인이 부담하여야 합니다.
                      </li>
                      <li>
                          회원은 본 약관 및 회사가 서비스와 관련하여 통지 또는 고지하는 내용과 관련 법령 등을 준수하여야 하며, 본 약관 및 통지 또는 고지 내용이나 관련 법령을 위반하거나 이행하지 아니하여 발생하는 손실, 손해에 대한 책임은 회원 본인이 부담하여야 합니다. 회사는 필요한 경우 회원의 관련 법령 등의 위반 사실을 정부 기관 또는 사법기관에 통지할 수 있습니다.
                      </li>
                      <li>
                          링콜 서비스와 관련하여 회원이 입력한 정보 및 그 정보와 관련하여 발생한 책임과 불이익은 회원이 부담하여야 합니다.
                      </li>
                      <li>
                          회원은 계정 관리를 철저히 하고 이를 제3자에게 이용하게 해서는 안 되며, 회원 본인의 계정을 도난당하거나 제3자가 사용하고 있음을 인지할 때는 바로 회사에 통보하고 회사의 안내가 있는 경우 그에 따라야 합니다. 회원의 계정 관리 소홀, 부정 사용 등에 의하여 발생하는 모든 책임과 불이익은 회원이 부담하여야 합니다.
                      </li>
                      <li>
                          회원은 유료 서비스 및 제휴 서비스 등에 대한 결제 시 반드시 정당하고 적법한 사용 권한을 가진 본인 명의의 결제 수단을 사용하여야 하며, 회사는 그 여부를 확인할 수 있습니다. 회사는 회원 결제 수단의 적법성 등에 대 한 확인이 완료될 때까지 링콜 서비스의 제공을 중단할 수 있고, 타인의 결제 수단을 임의로 사용함으로써 발생 하는 회사, 결제 수단의 적법한 소유자, 전자결제대행업자 또는 서비스 제공자 등의 손실과 손해에 대한 책임은 회원에게 있습니다.
                      </li>
                      <li>
                          회원은 회사가 서비스를 안전하게 제공할 수 있도록 협조하여야 하며, 회사가 회원의 본 약관 위반 등 부적절한 행위를 발견하여 회원에게 해당 행위에 대하여 소명을 요청할 경우 회원은 회사의 요청에 적극 응하여야 합니다.
                      </li>
                      <li>
                          회원은 분쟁이 발생한 경우 분쟁의 해결을 위하여 성실히 임하여야 하며, 분쟁 해결에 대한 회원의 불성실로 인하여 서비스 제공자 또는 회사에 손해가 발생한 경우 회원은 이에 대한 책임을 부담하여야 합니다.
                      </li>
                      <li>
                          회원은 회사가 정하고 인정하는 방식에 따라 링콜 포인트 및 혜택 등을 취득, 사용하여야 합니다.
                      </li>
                  </ol>
              </div>
              <div>
                  <h3 className='text-body1'>제18조 (회원의 금지사항)</h3>
                  <div>
                      회사는 링콜 서비스의 신뢰성을 제고하고 안전한 거래가 이루어질 수 있도록 회원의 다음과 같은 행위를 금지합니다.
                      <ol>
                          <li>
                              이용신청 또는 이용계약 변경 시 허위 사실을 기재하거나, 제3자의 명의, 결제 정보 등을 도용 또는 부정하게 사용하거나, 타인의 이동전화를 부정하게 사용하여 링콜 서비스를 이용하는 행위
                          </li>
                          <li>
                              회원의 링콜 계정 또는 링콜 이용계약 상의 지위를 타인에게 대여하거나 판매, 양도, 증여, 담보제공 등을 하는 행위
                          </li>
                          <li>
                              링콜 또는 링콜 서비스를 통하여 얻은 정보를 회사의 사전 승낙 없이 복제 또는 유통시키거나 상업적으로 이용하는 행위
                          </li>
                          <li>
                              회사가 제공하는 링콜 서비스, 유료서비스, 제휴 서비스 등의 정당한 이용방법에 의하지 않고, 링콜 시스템 내 정보를 변경하는 등 비정상적인 방법으로 위 서비스들을 이용하거나 시스템 등에 접근하는 행위
                          </li>
                          <li>
                              물품 판매 또는 용역제공을 가장하여 자금을 융통하는 것과 같이 여신전문금융업 법 등 관련 법령에 의하여 금지된 방법으로 비정상적인 결제를 하는 등의 부정거래 행위
                          </li>
                          <li>
                              회사 또는 제3자의 명예를 훼손하거나 각종 권리를 침해하거나 부적절한 행위로 인하여 손해를 입히는 행위
                          </li>
                          <li>
                              링콜 이용 과정에서 공공질서 및 미풍양속에 위반되는 내용 또는 허위의 정보, 문장, 도형, 음성 등을 적시하거나 유포하는 행위
                          </li>
                          <li>
                              링콜과 관련된 시스템 및 설비 등의 오동작이나 정보 등의 파괴 및 혼란을 유발하는 소프트웨어 바이러스, 기타 컴퓨터 코드, 파일, 프로그램 등을 등록 또는 유포하는 행위
                          </li>
                          <li>
                              회사가 정한 정당한 이용 방법에 의하지 않거나 부정한 방법으로 링콜 포인트 또는 혜택 등을 취득하거나 사용하는 행위
                          </li>
                          <li>
                              불법 프로그램 또는 변조된 프로그램 등을 사용하여 정상적인 링콜 서비스 제공을 방해하는 행위
                          </li>
                          <li>
                              고의적인 반복적인 호출 또는 신고 및 취소 등을 통해 회사의 링콜 서비스 제공 업무를 방해하는 행위
                          </li>
                          <li>
                              고의로 결제 미수를 발생시키거나 미수가 장기간 발생하여 정상적인 링콜 서비스 이용으로 보기 어려운 행위
                          </li>
                          <li>
                              타인의 개인정보를 수집, 저장, 공개하는 행위
                          </li>
                          <li>
                              회사의 직원이나 운영자를 가장·사칭하거나, 타인의 명의를 도용하여 링콜 또는 링콜 서비스와 관련된 글을 홈페이지 또는 인터넷 사이트 등에 게시하거나 회사 또는 제3자에게 E-mail 등을 발송하는 행위
                          </li>
                          <li>
                              불필요한 구급차 호출과 이용을 요구하는 행위 (소방기본법 시행에 따라 처벌받을 수 있습니다.)
                          </li>
                          <li>
                              관련 법령 또는 본 약관 및 이용 정책 등을 위반하는 행위
                          </li>
                          <li>
                              기타 불법적이거나 부적절한 행위
                          </li>
                      </ol>
                  </div>
              </div>
              <div>
                  <h3 className='text-body1'>제19조 (개인정보 보호 등)</h3>
                  <ol>
                      <li>
                          회사는 회원이 안전하게 링콜 서비스를 이용할 수 있도록 회원의 개인정보, 위치정보, 신용정보 등(이하 “개인정 보 등"이라 함)을 보호하기 위하여 관련 법령에 따라 보안 시스템 등을 갖추고 개인정보 등 보호 정책을 실시 합니다.
                      </li>
                      <li>
                          회사는 회원의 개인정보 등을 관련 법령상 필요한 경우 등을 제외하고 링콜 서비스를 제공하기 위한 목적 이외 의 용도로 사용하거나 회원의 동의 없이 제3자에게 제공하지 않습니다.
                      </li>
                      <li>
                          회사는 수집된 개인정보 등의 취급과 관리 등의 업무를 스스로 수행함을 원칙으로 합니다. 다만, 회사는 필요한 경우 회원의 동의를 받거나 통지를 한 후 위 업무의 일부 또는 전부를 회사가 선정한 회사에 위탁할 수 있습니다.
                      </li>
                      <li>
                          회원은 이용신청 당시 기재한 사항이 변경되었을 때는 즉시 변경 사항을 최신의 정보로 수정하여야 합니다. 다 만, 회사가 정한 정보 항목은 회사의 승인을 받아 수정할 수 있습니다.
                      </li>
                      <li>
                          전항에 따라 수정하지 않은 정보로 인하여 발생하는 손해는 당해 회원이 부담하고, 회사는 이에 대하여 귀책사 유가 없으면 책임을 지지 않습니다.
                      </li>
                      <li>
                          회원이 이용계약을 해지하는 경우, 회사는 관련 법령 및 개인정보처리방침에 따라 회원의 개인정보 등을 보유하 는 경우를 제외하고 해지 즉시 회원의 모든 정보를 삭제합니다.
                      </li>
                      <li>
                          회사의 개인정보 등 보호와 관련한 상세한 내용은 회사가 회사의 홈페이지 또는 링콜 내에 게시하는 개인정보 처리방침에 따릅니다. 
                      </li>
                  </ol>
              </div>
            </div>
            <h3>제5장 기타</h3>
            <div>
                <h3>제20조 (손해배상)</h3>
                <ol>
                    <li>
                        회원이 관련 법령 또는 본 약관 및 회사가 정한 운영정책 등을 위반함으로 인하여 회사에 손해가 발생하게 되 는 경우, 해당 회원은 회사에 발생한 손해를 배상하여야 합니다. 
                    </li>
                    <li>
                        회원이 링콜 또는 링콜 서비스를 이용함에 있어 행한 불법 행위나 제1항의 위반행위로 인하여 회사가 당해 회 원 이외의 제3자로부터 손해배상청구 또는 소송을 비롯한 각종 이의제기를 받는 경우, 당해 회원은 자신의 책 임과 비용으로 회사를 면책시켜야 하고, 그로 인하여 회사에 발생한 손해를 배상하여야 합니다.
                    </li>
                    <li>
                        회사의 고의나 과실에 의하여 회원에게 손해가 발생한 경우, 회사는 회원에게 해당 손해를 배상하여야 합니다.
                    </li>
                </ol>
            </div>
            <div>
                <h3>제21조 (분쟁의 해결 및 관할법원)</h3>
                <ol>
                    <li>
                        회사는 링콜 서비스의 이용과 관련한 불만 사항 등의 처리를 위한 고객센터를 운영합니다. 
                    </li>
                    <li>
                        링콜 서비스 이용과 관련하여 회사와 회원 사이에 분쟁이 발생한 경우, 회사와 회원은 분쟁의 해결을 위해 성실 히 협의합니다.
                    </li>
                    <li>
                        회사와 회원 사이에 제기된 소송은 대한민국 법을 준거법으로 합니다.
                    </li>
                    <li>
                        회사와 회원 사이에 발생한 분쟁에 대한 소송의 관할법원은 민사소송법에 따라 정합니다. 
                    </li>
                </ol>
            </div>
          </div>
        </div>
      </main>
      <Footer/>
    </div>
  )
}